import { render, staticRenderFns } from "./tel-select.vue?vue&type=template&id=0fee9e19&scoped=true&"
import script from "./tel-select.vue?vue&type=script&lang=js&"
export * from "./tel-select.vue?vue&type=script&lang=js&"
import style0 from "./tel-select.vue?vue&type=style&index=0&id=0fee9e19&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee9e19",
  null
  
)

export default component.exports